const countryStdCodes = [
  { country: 'Afghanistan', std: '+93' },
  { country: 'Albania', std: '+355' },
  { country: 'Algeria', std: '+213' },
  { country: 'Andorra', std: '+376' },
  { country: 'Angola', std: '+244' },
  { country: 'Argentina', std: '+54' },
  { country: 'Armenia', std: '+374' },
  { country: 'Australia', std: '+61' },
  { country: 'Austria', std: '+43' },
  { country: 'Azerbaijan', std: '+994' },
  { country: 'Bahamas', std: '+1-242' },
  { country: 'Bahrain', std: '+973' },
  { country: 'Bangladesh', std: '+880' },
  { country: 'Belarus', std: '+375' },
  { country: 'Belgium', std: '+32' },
  { country: 'Belize', std: '+501' },
  { country: 'Benin', std: '+229' },
  { country: 'Bhutan', std: '+975' },
  { country: 'Bolivia', std: '+591' },
  { country: 'Bosnia and Herzegovina', std: '+387' },
  { country: 'Botswana', std: '+267' },
  { country: 'Brazil', std: '+55' },
  { country: 'Brunei', std: '+673' },
  { country: 'Bulgaria', std: '+359' },
  { country: 'Burkina Faso', std: '+226' },
  { country: 'Burundi', std: '+257' },
  { country: 'Cambodia', std: '+855' },
  { country: 'Cameroon', std: '+237' },
  { country: 'Canada', std: '+1' },
  { country: 'Chad', std: '+235' },
  { country: 'Chile', std: '+56' },
  { country: 'China', std: '+86' },
  { country: 'Colombia', std: '+57' },
  { country: 'Congo', std: '+242' },
  { country: 'Costa Rica', std: '+506' },
  { country: 'Croatia', std: '+385' },
  { country: 'Cuba', std: '+53' },
  { country: 'Cyprus', std: '+357' },
  { country: 'Czech Republic', std: '+420' },
  { country: 'Denmark', std: '+45' },
  { country: 'Dominican Republic', std: '+1-809' },
  { country: 'Ecuador', std: '+593' },
  { country: 'Egypt', std: '+20' },
  { country: 'El Salvador', std: '+503' },
  { country: 'Estonia', std: '+372' },
  { country: 'Ethiopia', std: '+251' },
  { country: 'Finland', std: '+358' },
  { country: 'France', std: '+33' },
  { country: 'Georgia', std: '+995' },
  { country: 'Germany', std: '+49' },
  { country: 'Ghana', std: '+233' },
  { country: 'Greece', std: '+30' },
  { country: 'Guatemala', std: '+502' },
  { country: 'Honduras', std: '+504' },
  { country: 'Hong Kong', std: '+852' },
  { country: 'Hungary', std: '+36' },
  { country: 'Iceland', std: '+354' },
  { country: 'India', std: '+91' },
  { country: 'Indonesia', std: '+62' },
  { country: 'Iran', std: '+98' },
  { country: 'Iraq', std: '+964' },
  { country: 'Ireland', std: '+353' },
  { country: 'Israel', std: '+972' },
  { country: 'Italy', std: '+39' },
  { country: 'Jamaica', std: '+1-876' },
  { country: 'Japan', std: '+81' },
  { country: 'Jordan', std: '+962' },
  { country: 'Kazakhstan', std: '+7' },
  { country: 'Kenya', std: '+254' },
  { country: 'Kuwait', std: '+965' },
  { country: 'Kyrgyzstan', std: '+996' },
  { country: 'Laos', std: '+856' },
  { country: 'Latvia', std: '+371' },
  { country: 'Lebanon', std: '+961' },
  { country: 'Libya', std: '+218' },
  { country: 'Lithuania', std: '+370' },
  { country: 'Luxembourg', std: '+352' },
  { country: 'Macau', std: '+853' },
  { country: 'Madagascar', std: '+261' },
  { country: 'Malaysia', std: '+60' },
  { country: 'Maldives', std: '+960' },
  { country: 'Mali', std: '+223' },
  { country: 'Malta', std: '+356' },
  { country: 'Mexico', std: '+52' },
  { country: 'Moldova', std: '+373' },
  { country: 'Monaco', std: '+377' },
  { country: 'Mongolia', std: '+976' },
  { country: 'Morocco', std: '+212' },
  { country: 'Mozambique', std: '+258' },
  { country: 'Myanmar', std: '+95' },
  { country: 'Nepal', std: '+977' },
  { country: 'Netherlands', std: '+31' },
  { country: 'New Zealand', std: '+64' },
  { country: 'Nigeria', std: '+234' },
  { country: 'North Korea', std: '+850' },
  { country: 'Norway', std: '+47' },
  { country: 'Oman', std: '+968' },
  { country: 'Pakistan', std: '+92' },
  { country: 'Palestine', std: '+970' },
  { country: 'Panama', std: '+507' },
  { country: 'Papua New Guinea', std: '+675' },
  { country: 'Paraguay', std: '+595' },
  { country: 'Peru', std: '+51' },
  { country: 'Philippines', std: '+63' },
  { country: 'Poland', std: '+48' },
  { country: 'Portugal', std: '+351' },
  { country: 'Qatar', std: '+974' },
  { country: 'Romania', std: '+40' },
  { country: 'Russia', std: '+7' },
  { country: 'Rwanda', std: '+250' },
  { country: 'Saudi Arabia', std: '+966' },
  { country: 'Serbia', std: '+381' },
  { country: 'Singapore', std: '+65' },
  { country: 'Slovakia', std: '+421' },
  { country: 'Slovenia', std: '+386' },
  { country: 'South Africa', std: '+27' },
  { country: 'South Korea', std: '+82' },
  { country: 'Spain', std: '+34' },
  { country: 'Sri Lanka', std: '+94' },
  { country: 'Sudan', std: '+249' },
  { country: 'Sweden', std: '+46' },
  { country: 'Switzerland', std: '+41' },
  { country: 'Syria', std: '+963' },
  { country: 'Taiwan', std: '+886' },
  { country: 'Tajikistan', std: '+992' },
  { country: 'Tanzania', std: '+255' },
  { country: 'Thailand', std: '+66' },
  { country: 'Tunisia', std: '+216' },
  { country: 'Turkey', std: '+90' },
  { country: 'Turkmenistan', std: '+993' },
  { country: 'Uganda', std: '+256' },
  { country: 'Ukraine', std: '+380' },
  { country: 'United Arab Emirates', std: '+971' },
  { country: 'United Kingdom', std: '+44' },
  { country: 'United States', std: '+1' },
  { country: 'Uruguay', std: '+598' },
  { country: 'Uzbekistan', std: '+998' },
  { country: 'Vatican City', std: '+379' },
  { country: 'Venezuela', std: '+58' },
  { country: 'Vietnam', std: '+84' },
  { country: 'Yemen', std: '+967' },
  { country: 'Zambia', std: '+260' },
  { country: 'Zimbabwe', std: '+263' },
  { country: 'Other', std: '' }, // fallback for unlisted countries
];

export default countryStdCodes;
